const buildStatusCheckDataObject = (applicantId, uData) => {
  const dataObject = {
    qdbapi: {
      udata: uData,
      ApplicantId: applicantId,
      fmt: "structured",
    },
  };
  if (applicantId) {
    dataObject.qdbapi.query = `{'120'.EX.'${applicantId}'}`;
  }
  return dataObject;
};

export default buildStatusCheckDataObject;
